var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectangleProgress90(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_936_4969)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_936_4969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 4C45.9706 4 50 8.02944 50 13V41C50 45.9706 45.9706 50 41 50H13C8.02944 50 4 45.9706 4 41V13C4 10.3507 5.1447 7.96879 6.96647 6.32184C7.40874 5.92202 8.0898 6.07571 8.38627 6.59297C8.64161 7.03849 8.51709 7.59924 8.14707 7.95528C6.82354 9.2288 6 11.0182 6 13V41C6 44.866 9.13401 48 13 48H41C44.866 48 48 44.866 48 41V13C48 9.13401 44.866 6 41 6H28C27.4477 6 27 5.55228 27 5C27 4.44772 27.4477 4 28 4H41Z",
    fill: "#06C6C6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_936_4969",
    x: -1,
    y: -1,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_936_4969"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.027451 0 0 0 0 0.94902 0 0 0 0 0.94902 0 0 0 0.48 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_936_4969"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_936_4969",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_936_4969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangleProgress90);
export default __webpack_public_path__ + "static/media/rectangle-progress-90.a6255eda46b804c1fb5fb9afbfc2d9f3.svg";
export { ForwardRef as ReactComponent };